export type CheckCodeNotificationProps = {
  phone?: string;
};

export const CheckCodeNotification = ({ phone }: CheckCodeNotificationProps) => {
  return (
    <>
      {phone ? (
        <p>
          We've sent a one-time password to validate your identity
        </p>
      ) : (
        <p>Number verification is disabled</p>
      )}
    </>
  );
};
